/**
 * Configuration object for serializing a mark to markdown.
 * Based on ProseMirror's markdown serializer specification.
 *
 * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts
 */
export interface MarkSerializerConfig {
	open: string;
	close: string;
	mixable: boolean;
	escape?: boolean;
	expelEnclosingWhitespace?: boolean;
}

/**
 * Returns a markdown serializer configuration for disabled marks.
 *
 * When a mark is disabled (e.g., italic in AI prompt input), but can still
 * appear in the document through paste operations, this serializer strips
 * the formatting by outputting plain text.
 *
 * This prevents serialization errors while respecting the disabled state.
 * Similar to how disabled nodes are rendered as paragraphs, disabled marks
 * are rendered as plain text with no markdown formatting.
 *
 */
export function disabledMarkSerializer(): MarkSerializerConfig {
	return {
		open: '',
		close: '',
		mixable: true,
		expelEnclosingWhitespace: false,
	};
}
